import { Box, Stack, styled } from "@mui/material";

export const PreviewContainerTemplate = styled(Box)`
  margin-top: 1rem;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  @media only screen and (min-width: 992px) {
    & {
      display: none;
    }
  }
`;

export const PreviewContainerFixed = styled(Box)`
  width: 40%;
  position: relative;
  @media only screen and (max-width: 992px) {
    & {
      display: none;
    }
  }
`;

export const FormContainer = styled(Box)`
  max-width: 50rem;
  width: 60%;
  @media only screen and (max-width: 992px) {
    & {
      max-width: unset;
      width: 100%;
    }
  }
`;

export const LandingPageWizardShell = styled(Stack)`
  width: 100%;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 900px) {
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }
`;
